import L from 'leaflet'
import 'leaflet-draw'
import 'leaflet.locatecontrol'
import Gesture from 'leaflet-gesture-handling';
import {GeoSearchControl} from 'leaflet-geosearch'
import CustomProvider from "./Provider";


export default class Maps {


    constructor(lng, lat, zoom) {
        this.lng = lng
        this.lat = lat
        this.gesture = L.Map.addInitHook("addHandler", "gestureHandling", Gesture);
        this.map = new L.Map('mapPropositionReport', {
            center: new L.LatLng(this.lat, this.lng),
            zoom: zoom,
            zoomControl: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            gestureHandling: true,
            gestureHandlingOptions: {
                text: {
                    touch: "Utiliser deux doigts pour vous déplacer sur la carte",
                    scroll: "Pour zoomer, utilisez CTRL + Molette",
                    scrollMac: "Pour zoomer, utilisez \u2318 + Molette"
                }
            }
        })
        this.editableLayer = L.featureGroup()
        this.icon = new L.DivIcon({
            iconSize: new L.Point(30, 47),
            className: 'leaflet-div-icon leaflet-editing-icon creasit-marker proposition-report',
            iconAnchor: [17, 46],
            popupAnchor: [-3, -45]
        })
        this.marker = null
        // this.clusterGroup = ''
    }

    /**************
     * Init the map and display it
     *
     ***************/
    get init() {
        // Init the map
        // Source : https://leaflet.github.io/Leaflet.draw/docs/examples/full.html

        let osmUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            osmAttrib = '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            osm = L.tileLayer(osmUrl, {attribution: osmAttrib});
        osm.addTo(this.map)

        let satelliteView = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
            {
                attribution: 'Source: Esri, Maxar, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community'
            }
        )

        let baseMaps = {
            "<img src='/wp-content/plugins/creasit-reports/assets/dist/front/archive/images/osm.png' />": osm,
            "<img src='/wp-content/plugins/creasit-reports/assets/dist/front/archive/images/satellite.png' />": satelliteView
        }

        L.control.layers(baseMaps, null, {position: 'bottomright'}).addTo(this.map);


        this.editableLayer.addTo(this.map);

        L.control.zoom({
            position: 'bottomright',
            zoomInTitle: 'Zoomer',
            zoomOutTitle: 'Dézoomer'
        }).addTo(this.map)

        L.Icon.Default.prototype.options.iconUrl = 'creasit-marker.png';

        let provider = new CustomProvider()

        let searchControl = new GeoSearchControl({
            position: 'topright',
            style: 'button',
            showMarker: false,
            showPopup: false,
            maxMarkers: 1,
            maxSuggestions: 5,
            retainZoomLevel: true,
            animateZoom: true,
            searchLabel: "Rechercher une adresse",
            notFoundMessage: "Aucun résultat à cette adresse",
            // messageHideDelay: 3000,
            zoomLevel: 30,
            classNames: {
                container: 'leaflet-bar leaflet-control leaflet-control-geosearch',
                button: 'leaflet-bar-part leaflet-bar-part-single',
                resetButton: 'reset',
                msgbox: 'leaflet-bar message',
                form: '',
                input: '',
            },
            // autoComplete: true,
            // autoCompleteDelay: 250,
            // autoClose: false,
            // keepResult: false,
            // updateMap: true,
            provider: provider,
        })
        this.map.addControl(searchControl)
    }

    /**************
     * Init the control and display
     *
     ***************/
    get control() {

        const drawControl = new L.Control.Draw({
            position: 'topleft',
            draw: {
                marker: {
                    icon: this.icon
                },
                polyline: false,
                circle: false,
                polygon: false,
                rectangle: false,
                circlemarker: false,
            },
            edit: {
                featureGroup: this.editableLayer,
                edit: false,
                remove: false
            },
        })

        drawControl.addTo(this.map)

        L.control.locate({
            position: 'topright',
            strings: {
                title: "Ajouter un marqueur à votre position",
                popup: false
            },
            setView: false,
            flyTo: false,
            showCompass: false,
            drawCircle: false,
            drawMarker: false,
            clickBehavior: {
                outOfView: 'stop'
            }
        }).addTo(this.map);
    }


    /**************
     * Create Element
     *
     ***************/
    createElement(layer, position) {
        let geoJson

        geoJson = layer.toGeoJSON()

        //this.editableLayer.addLayer(layer)
        // layer.addTo(this.clusterGroup)

        return JSON.stringify(geoJson);
    }

    markerMap(lat, lng) {
        if (this.marker instanceof L.Marker) {
            this.map.removeLayer(this.marker)
        }

        this.marker = new L.Marker([lat, lng], {draggable: false, icon: this.icon, autoPan: true});

        //this.editableLayer.addLayer(marker)

        this.marker.addTo(this.map)

        this.map.flyTo([lat, lng], 17)

        return this.marker
    }

    /*
    * Query Address
    * */

    queryAddressByLatLng(LatLng, fieldGroup) {
        const Query = new PostsQuery()
        // Init the url used to get the address from coordinates
        const URL = 'https://apis.creasrv.net/osm_reverse?lat=' + LatLng.lat + '&lon=' + LatLng.lng + '&format=json&addressdetails=1';

        // Call the API
        Query.secureFetchAPI(URL).then(
            data => {
                this.fillAddressFields(fieldGroup, data.address)
            }
        )
    }

    fillAddressFields(fieldGroup, data) {
        let $addressInput = fieldGroup.querySelector('[data-name="address"] input')
        let $zipCodeInput = fieldGroup.querySelector('[data-name=zipcode] input')
        let $cityInput = fieldGroup.querySelector('[data-name=city] input')

        // Store the address object
        let house_number = ''
        let road = ''
        let postcode = ''
        let city = ''

        if ('house_number' in data) {
            house_number = data.house_number
        }
        if ('road' in data) {
            road = data.road
        }
        if ('postcode' in data) {
            postcode = data.postcode
        }
        if ('city' in data) {
            city = data.city
        } else if ('town' in data) {
            city = data.town
        } else if ('village' in data) {
            city = data.village
        }

        $addressInput.value = house_number + ' ' + road
        $zipCodeInput.value = postcode
        $cityInput.value = city
    }

    /**************
     * Translate the Leaflet Draw Control
     *
     ***************/
    doTranslation() {
        // HANDLERS TRAD
        const drawLocalHandlers = L.drawLocal.draw.handlers

        drawLocalHandlers.circle.radius = 'Rayon'
        drawLocalHandlers.circle.tooltip.start = 'Cliquez sur la carte puis déplacez votre souris pour ajouter une ellipse'

        drawLocalHandlers.marker.tooltip.start = 'Cliquez sur la carte pour ajouter un marqueur'

        drawLocalHandlers.polygon.tooltip.start = 'Cliquez sur la carte pour commencer le polygone'
        drawLocalHandlers.polygon.tooltip.cont = 'Cliquez sur la carte pour continuer le polygone'
        drawLocalHandlers.polygon.tooltip.end = 'Cliquez sur le premier point pour terminer le polygone'

        drawLocalHandlers.polyline.error = '<strong>Erreur :</strong> les bords du tracé ne peuvent se croiser'
        drawLocalHandlers.polyline.tooltip.cont = 'Cliquez sur la carte pour continuer le tracé'
        drawLocalHandlers.polyline.tooltip.end = 'Cliquez sur le dernier point pour terminer la ligne'
        drawLocalHandlers.polyline.tooltip.start = 'Cliquez sur la carte pour commencer le tracé'
        drawLocalHandlers.polyline.tooltipstart = 'Cliquez sur la carte pour commencer le tracé'

        drawLocalHandlers.rectangle.tooltip.start = 'Cliquez sur la carte puis déplacez votre souris pour ajouter un rectangle'

        drawLocalHandlers.simpleshape.tooltip.end = 'Relâchez votre souris pour terminer la forme'

        // TOOLBAR TRAD
        const drawLocalToolbar = L.drawLocal.draw.toolbar

        drawLocalToolbar.actions.text = 'Annuler'
        drawLocalToolbar.actions.title = 'Annuler l\'action'

        drawLocalToolbar.buttons.circle = 'Ajouter une ellipse'
        drawLocalToolbar.buttons.marker = 'Ajouter un marqueur'
        drawLocalToolbar.buttons.polygon = 'Ajouter un polygone'
        drawLocalToolbar.buttons.polyline = 'Ajouter un tracé'
        drawLocalToolbar.buttons.rectangle = 'Ajouter un rectangle'

        drawLocalToolbar.finish.text = 'Terminer'
        drawLocalToolbar.finish.title = 'Terminer le tracé'

        drawLocalToolbar.undo.text = 'Supprimer le dernier point'
        drawLocalToolbar.undo.title = 'Supprimer le dernier point placé'

        const editLocalToolbar = L.drawLocal.edit.toolbar

        editLocalToolbar.actions.cancel.text = 'Annuler'
        editLocalToolbar.actions.cancel.title = 'Annuler l\'édition et toutes les modifications'

        editLocalToolbar.actions.save.text = 'Confirmer'
        editLocalToolbar.actions.save.title = 'Confirmer tous les changements'

        editLocalToolbar.buttons.edit = 'Editer les points'
        editLocalToolbar.buttons.editDisabled = 'Aucun point à éditer'
        editLocalToolbar.buttons.remove = 'Supprimer des éléments'
        editLocalToolbar.buttons.removeDisabled = 'Aucun point à supprimer'

        const editLocalHandlers = L.drawLocal.edit.handlers

        editLocalHandlers.remove.tooltip.text = 'Cliquez sur un élément pour le supprimer'

    }

}
